import { useCallback } from 'react';
import { FopiFundsDtoResponse } from '@asset-metrix/portal-gateway-client-js';
import { useQuery } from '@tanstack/react-query';

import { fetchFopiFundsData } from '../../api/portalGateway/fopiData';

export const useFundTableDataQuery = (enabled: boolean) => {
  const select = useCallback((data: FopiFundsDtoResponse) => {
    return {
      ...data,
      data: {
        ...data.data,
        items: data.data.items.map((fund) => ({
          ...fund,
          Fund_Name: fund.fundName,
        })),
      },
    };
  }, []);

  return useQuery({
    queryKey: ['fopi_funds'],
    queryFn: fetchFopiFundsData,
    enabled,
    select,
  });
};
